import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from "react-table";
import Select from 'react-select';
import 'react-table/react-table.css';




const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class AuSuburbList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            ausuburbs: [],
            filter: {},
            showAlert: false,
            showWarning: false,
            errorMessage: "",
            savingNewRecord: false,
            suburb: null,
            scope: null,
            dataSetPrimaryKey: "postconv_id",
            cityscopeOptions: [],
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    

    async componentDidMount() {
        console.log("In AuSuburbList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const ausuburbs = await this.getSuburbs({
                                                        suburb: null,
                                                        scope: null
                                                    });
            await this.getCityscopes();
            this.setState({ ausuburbs });
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ ausuburbs: [] });        
    }


    
    async getSuburbs(filter) {
        console.log("Inside getSuburbs() ");
        
        return API.get("colin", "/ausuburbs", {'queryStringParameters': filter});
      
    }

    async getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token }).then((cityscopeOptions) => {
                if (cityscopeOptions) {
                    this.setState(state => ({ cityscopeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }

    addRecord = async event => {
        let ausuburbs = [...this.state.ausuburbs];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        ausuburbs.unshift({
            cityscope: "",
            suburb: "",
            state: "",
            postcode: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({ausuburbs});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/ausuburbs/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/ausuburbs/${record["postconv_id"]}`, {
            body: record
        });
        
        

       
    }

    

    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

   

    async handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
        
        const ausuburbs = await this.getSuburbs( {
                            suburb: this.state.suburb,
                            scope: this.state.scope
                        });

        this.setState({ ausuburbs });

        this.setState({ isLoading: false });
                
     }




    validateRecord(record) {

       
        //Check street name not blank
        if (record.suburb === "") {
            return [false,"Suburb cannot be blank. The record has not been saved"];
        }
        if (record.state === "") {
            return [false,"State cannot be blank. The record has not been saved"];
        }
        if (record.postcode === "") {
            return [false,"Postcode cannot be blank. The record has not been saved"];
        }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let ausuburbs = [...this.state.ausuburbs];
        ausuburbs[cellInfo.index][cellInfo.column.id] = event.target.value;
        ausuburbs[cellInfo.index].modified = true;
        this.setState({ausuburbs});
    };
    handleNumberChange = (cellInfo, event) => {
        let ausuburbs = [...this.state.ausuburbs];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        ausuburbs[cellInfo.index][cellInfo.column.id] = Number(val);
        ausuburbs[cellInfo.index].modified = true;
        this.setState({ausuburbs});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let ausuburbs = [...this.state.ausuburbs];
        ausuburbs[cellInfo.index][cellInfo.column.id] = event.target.checked;
        ausuburbs[cellInfo.index].modified = true;
        this.setState({ausuburbs});
    };

    handleDateChange = (cellInfo, event) => {
        let ausuburbs = [...this.state.ausuburbs];
        ausuburbs[cellInfo.index][cellInfo.column.id] = new Date(event);
        ausuburbs[cellInfo.index].modified = true;
        this.setState({ausuburbs});

    }

    handleCityscopeChange = async (cellInfo, selectedCityscopes) => {
        let ausuburbs = [...this.state.ausuburbs];
        const values = (selectedCityscopes) ? selectedCityscopes.map(co => co.value).join(';') : null;
        ausuburbs[cellInfo.index][cellInfo.column.id] = values;
        ausuburbs[cellInfo.index].modified = true;
        this.setState({ausuburbs});
    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false, showWarning: false });
        let ausuburbs = [...this.state.ausuburbs];
        for (var i=0; i<ausuburbs.length; i++){
            
            
            if (ausuburbs[i].hasOwnProperty("modified")) {
                if (ausuburbs[i].modified === true) {
                    console.log("Is modified");
                    const validation = this.validateRecord(ausuburbs[i]);
                    if (validation[0] === true) {
                        console.log("Is valid");
                        
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (ausuburbs[i].hasOwnProperty("new_record")) {
                                if (ausuburbs[i].new_record === true) {
                                    
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(ausuburbs[i]);
                            if (result.result) {
                                ausuburbs[i].modified = false;
                                if (ausuburbs[i].hasOwnProperty("new_record")) {
                                    if (ausuburbs[i].new_record === true) {

                                        ausuburbs[i][this.state.dataSetPrimaryKey] = result.id;
                                        ausuburbs[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    ausuburbs[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                this.setState({ savingNewRecord: false });
                            }
                        }
                    

                
            }
            else {
                this.setState({ errorMessage: validation[1] });
                if (ausuburbs[i].new_record === true) {
                    this.setState({ showWarning: true });
                }
                else{
                    this.setState({ showAlert: true });
                }
                this.setState({ savingNewRecord: false });
                return;
            }
        }
    }
        }   
        if (ausuburbs[0].hasOwnProperty("sort_order")) {
            ausuburbs.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({ausuburbs});

    }


    renderEditable = cellInfo => {
        const cellValue = this.state.ausuburbs[cellInfo.index][cellInfo.column.id];

        if (cellInfo.column.id === 'cityscope') {
            const selectedCityscopes = (cellValue || '')
                .split(';')
                .map(cs => this.state.cityscopeOptions.find(co => co.value === cs))
                .filter(co => co !== null);

            return <Select
                value={selectedCityscopes}
                onChange={this.handleCityscopeChange.bind(null, cellInfo)}
                options={this.state.cityscopeOptions}
                onBlur={this.handleSave.bind(null, cellInfo)}
                isMulti
            />
        }

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'postconv_id',
                Header: 'ID',
                maxWidth: 150,
                accessor: 'postconv_id' 
                

        }
        , {
                id: 'cityscope',
                Header: 'Cityscope',            
                accessor: 'cityscope',
                maxWidth: 250,
                Cell: this.renderEditable
                

            }, {
                id: 'suburb',
                Header: 'Suburb',            
                accessor: 'suburb',
                maxWidth: 150,
                Cell: this.renderEditable

            }
            ,
            {
                id: 'state',
                Header: 'State',              
                accessor: 'state',
                maxWidth: 150,
                Cell: this.renderEditable

            },
            {
                id: 'postcode',
                Header: 'Postcode',
                maxWidth: 150,
                accessor: 'postcode',
                Cell: this.renderEditable

            },
            {
                id: 'created_by',
                Header: 'Created By',
                maxWidth: 150,
                accessor: 'created_by'
            },
            {
                id: 'last_edited_by',
                Header: 'Last Edited By',
                maxWidth: 150,
                accessor: 'last_edited_by'
            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={true}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="ausuburbs">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showWarning &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                <Form onSubmit={this.handleSubmit}>
                    <Form.Row >

                        
                        <Col lg={2}>
                            <Form.Group controlId="suburb">
                                <Form.Control
                                    value={this.state.suburb}
                                    onChange={this.handleChange}
                                    componentClass="input"
                                    type="text"
                                    placeholder="Suburb"
                                />
                            </Form.Group>
                            </Col>
                        
                        <Col lg={2}>
                        <Form.Group controlId="scope">
                                <Form.Control
                                    type="input"
                                    value={this.state.scope}
                                    onChange={this.handleChange}
                                    placeholder="Cityscope" />
                            
                            </Form.Group>
                        </Col>                        
                        <Col lg={2}>
                        <Button type="submit" className="float-left">Search</Button>
                        </Col>
                        
                       

                    </Form.Row>
                </Form>
                        
                <Row >
                    <Col className="text-right" >                            
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.ausuburbs) : this.renderTable(this.state.ausuburbs)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="SuburbList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
